import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flow-header" }
const _hoisted_2 = {
  ref: "boxes",
  class: "flow-boxes"
}
const _hoisted_3 = { class: "box-day-text" }
const _hoisted_4 = { class: "box-schedule-text" }
const _hoisted_5 = {
  key: 0,
  class: "mastered-celebration"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_empty_box_icon = _resolveComponent("empty-box-icon")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_lottie_animation = _resolveComponent("lottie-animation")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!

  return (_openBlock(), _createBlock(_component_ion_card, { class: "flow-container" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_card_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ion_card_subtitle, {
              id: "leitner-flow-title",
              class: "flow-title"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode(" How the Leitner System Works ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_ion_badge, {
              color: "primary",
              class: "flow-badge"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.currentBoxDayLabel), 1)
              ]),
              _: 1
            })
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("p", { class: "flow-hint" }, "See how a word moves between boxes as you remember or forget it.", -1)),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ion_row, {
              class: "boxes-grid display-flex ion-justify-content-center",
              role: "list",
              "aria-labelledby": "leitner-flow-title"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boxes, (box) => {
                  return (_openBlock(), _createBlock(_component_ion_col, {
                    key: box.number,
                    sizeXs: "6",
                    sizeSm: "4",
                    sizeMd: "3",
                    sizeLg: "3",
                    sizeXl: "2",
                    role: "listitem",
                    "aria-current": box.number === _ctx.currentBox ? 'step' : undefined
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["box-item", {
                                active: box.number === _ctx.currentBox,
                                mastered: _ctx.currentBox === _ctx.lastBox && box.number === _ctx.lastBox,
                            }])
                      }, [
                        _createVNode(_component_ion_card, { class: "transparent box-card" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_empty_box_icon, {
                              class: "box-icon",
                              "color-variable": `--leitner-box-${box.number}`,
                              "aria-hidden": "true",
                              focusable: "false"
                            }, null, 8, ["color-variable"]),
                            _createElementVNode("span", _hoisted_3, _toDisplayString(box.dayLabel), 1),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(box.dueText), 1)
                          ]),
                          _: 2
                        }, 1024),
                        (_ctx.isMastered && box.number === _ctx.lastBox)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_lottie_animation, {
                                class: "mastered-celebration__animation",
                                "aria-hidden": "true",
                                "animation-data": _ctx.masteredAnimation,
                                loop: true
                              }, null, 8, ["animation-data"])
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["aria-current"]))
                }), 128))
              ]),
              _: 1
            }),
            (_ctx.hasWordChip)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "word-chip",
                  style: _normalizeStyle(_ctx.wordChipStyle),
                  "aria-hidden": "true"
                }, null, 4))
              : _createCommentVNode("", true)
          ], 512),
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                "size-sm": "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    color: "success",
                    "aria-label": "Remembered, move this word forward one box",
                    disabled: _ctx.currentBox === _ctx.lastBox,
                    onClick: _ctx.moveForward
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: _ctx.faArrowRight,
                        class: "ion-padding-end",
                        "aria-hidden": "true"
                      }, null, 8, ["icon"]),
                      _cache[1] || (_cache[1] = _createTextVNode(" Remembered ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "12",
                "size-sm": "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    color: "warning",
                    "aria-label": "Forgot, move this word back one box",
                    disabled: _ctx.currentBox === _ctx.firstBox,
                    onClick: _ctx.moveBackward
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: _ctx.faArrowLeft,
                        class: "ion-padding-end",
                        "aria-hidden": "true"
                      }, null, 8, ["icon"]),
                      _cache[2] || (_cache[2] = _createTextVNode(" Forgot ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "12",
                "size-sm": "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    color: "lightest",
                    "aria-label": "Reset, move this word back to Box 1",
                    onClick: _ctx.resetFlow
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        icon: _ctx.faRefresh,
                        class: "ion-padding-end",
                        "aria-hidden": "true"
                      }, null, 8, ["icon"]),
                      _cache[3] || (_cache[3] = _createTextVNode(" Reset ", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("p", {
            class: _normalizeClass(["status-banner", _ctx.statusType]),
            role: "status"
          }, _toDisplayString(_ctx.statusMessage), 3)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}